
import { AssignDiagnosticLessonsModel, StudentForDiagnostic, AssignStudentDiagnosticLessonsModel, 
    DiagnosticRemoveFromSkipStudentModel, CreateDiagnosticVM, DiagnosticLessonsSkipStudentModel, 
    UnassignDiagnosticLessonsVM, ViewWorkDataModel, ViewWorkDataVM, SubmitViewWorkModel, SubmitViewWorkResponseModel, 
    UnAssignModel, CreateAssignmentsModel, ClassWithStudentsForListing, CreateAssignmentOptions, CreateAccountModel, 
    CurriculaVMModel, ExistingStudentCurriculumRegisterModel, RegisterNewStudent, SelectedCurriculumModel, StudentModel, 
    StudentCourseModel, CurriculumViewListing, CurriculumProductLevelPrice, PaymentProviderRequestResult, PaymentFailureRedirectModel, 
    PaymentSuccessRedirectModel, SelfGetLessonReturnModel, SelfServiceGetLessonModel, DemoRedirectModel, GetDemoRedirectModel, 
    LoginAccountModel, LoginAccountResult, ConsumerCurriculumJargon,  DiagnosticReport, StudentConsumerCurriculum,
    LoginAsStudentModel,
    DemoResultData,
    StudentConsumerCurriculumRequest, EmailConfirmationModel, ExistingStudentConsumerCurriculumRegisterModel, DiagnosticReportRequest, StandardsGrowthReportModel, HasAlreadyPaidRedirectModel, ViewWorkDialogAssignmentAttempt, GetViewWorkDialogAssignmentAttempts, NotLoggedInReturnModel} from './../../Elearning-Models';



import { DiagnosticVM, ReassignStudentModel, LessonProgressLockSaveModel, LessonProgressSaveGradeModel, LessonProgressSaveModel, LessonProgressReleaseAllByStudent, LessonProgressReleaseAllResult, LessonProgressReleaseAllByAssignment, DiagnosticsList, DiagnosticSkipStudentModel, AssignAllDiagnosticModel, AssignStudentDiagnosticModel } from 'src/app/Elearning-Models';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { IAPIErrorHandlingService } from './IAPIErrorHandlingService';
import { IServiceFactory } from '../service-factory';
import { Observable, of } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ELearningDashboardClass, Teacher, Teachers, ELearningDashboardState, StudentLesson, Lesson, StudentVM, AssignmentVM, GradebookVM, ClassForListing, DiagnosticsVM } from '../../Elearning-Models';
import { IAPIService } from './IAPIService';
import { stringToKeyValue } from '@angular/flex-layout/extended/typings/style/style-transforms';


@Injectable({
    providedIn: 'root'
})

export class APIService extends IAPIErrorHandlingService implements IAPIService{

    httpUrl = "";
    serviceFactory: IServiceFactory;

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    constructor(private http: HttpClient){
        super();
    }
 
    ShowGradebookStudentAssignmentPagesCreateAssignmentInterfaces(): Observable<boolean>{
        return of(false); // THIS IS THE SERVICE TO HIDE THE CREATE ASSIGNMENT INTERFACES IN THE GRADEBOOK PAGES SINCE WE NEED TO DO FURTHER RESEARCH ON IT.
    }

    IsLoggedIn():Observable<NotLoggedInReturnModel>{
        let functionName = "IsLoggedIn";
        let callUrl = `/api/ConsumerCurriculum/IsLoggedIn`;
        let v = this.httpGet<NotLoggedInReturnModel>(callUrl, functionName);
        return v;
    }

    GetConsumerCurriculumJargon():Observable<ConsumerCurriculumJargon>{
        let functionName = "GetConsumerCurriculumJargon";
        let callUrl = `/api/ELearning/ConsumerCurriculum/GetConsumerCurriculumJargon`;
        let v = this.httpGet<ConsumerCurriculumJargon>(callUrl, functionName);
        return v;
    }

    IsConsumerCurriculum(): Observable<boolean>{
        let functionName = "IsConsumerCurriculum";
        let callUrl = `/api/ConsumerCurriculum/IsConsumerCurriculum`;
        let v = this.httpGet<boolean>(callUrl, functionName);
        return v;
    }

    ValidateUserName(email: string):Observable<boolean>{
        let functionName = "ValidateUserName";
        let callUrl = `/api/ELearning/ConsumerCurriculum/ValidateUserName/` + email;
        let v = this.httpGet<boolean>(callUrl, functionName);
        return v;
    }

    GetClassListByTeacher(): Observable<ClassForListing[]> {
        let functionName = "GetClassListByTeacher";
        let callUrl = `/api/ELearning/ClassList`
        let v = this.httpGet<ClassForListing[]>(callUrl, functionName);
        return v;
    }

    GetClassListByTeacherAndStudentID(studentID: number): Observable<ClassForListing[]> {
        let functionName = "GetClassListByTeacherAndStudentID";
        let callUrl = `/api/ELearning/ClassList/Student/`
        + studentID.toString()
        let v = this.httpGet<ClassForListing[]>(callUrl, functionName);
        return v;
    }

    ReassignStudent(model: ReassignStudentModel): Observable<boolean> {
        let functionName = "ReassignStudent";
        let callUrl = '/api/ELearning/Reassign';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    LockAssignmentForStudent(model: LessonProgressLockSaveModel): Observable<boolean> {
        let functionName = "LockAssignmentForStudent";
        let callUrl = '/api/ELearning/LockAssignment';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    SaveGradeForStudent(model: LessonProgressSaveGradeModel): Observable<boolean> {
        let functionName = "SaveGradeForStudent";
        let callUrl = '/api/ELearning/SaveGrade';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    UnassignOneOrAllAssignments(model: UnAssignModel): Observable<boolean>{
        let functionName = "UnassignOneOrAllAssignments";
        let callUrl = '/api/ELearning/Unassign';
        let requestString = JSON.stringify(model, this.replacer);
        //let formattedRequestString = "'" + requestString + "'";
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    ReleaseGradeForStudent(model: LessonProgressSaveModel): Observable<boolean> {
        let functionName = "ReleaseGradeForStudent";
        let callUrl = '/api/ELearning/ReleaseGrade';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    ReleaseKeyForStudent(model: LessonProgressSaveModel): Observable<boolean> {
        let functionName = "ReleaseKeyForStudent";
        let callUrl = '/api/ELearning/ReleaseKey';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    ReleaseAllGradesByStudentID(model: LessonProgressReleaseAllByStudent): Observable<boolean> {
        let functionName = "ReleaseAllGradesByStudentID";
        let callUrl = '/api/ELearning/ReleaseAllByStudent';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    ReleaseAllGradesByAssignmentID(model: LessonProgressReleaseAllByAssignment): Observable<boolean> {
        let functionName = "ReleaseAllGradesByAssignmentID";
        let callUrl = '/api/ELearning/ReleaseAllByAssignment';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    GetLessonProgressByStudentAndLessonVersionID(classid: number, studentid: number, lessonversionid: number): Observable<StudentVM> {
        let functionName = "GetLessonProgressByStudentID";
        let callUrl = `/api/ELearning/GetLessonProgress/Class/`
        + classid.toString()
        + `/LessonVersion/` + lessonversionid.toString()
        + `/Student/` + studentid.toString();
        let v = this.httpGet<StudentVM>(callUrl, functionName);
        return v;
    }

    GetLessonProgressByStudentID(classid: number, studentid: number): Observable<StudentVM> {
        let functionName = "GetLessonProgressByStudentID";
        let callUrl = `/api/ELearning/GetLessonProgress/Class/`
        + classid.toString()
        + `/Student/` + studentid.toString();
        let v = this.httpGet<StudentVM>(callUrl, functionName);
        return v;
    }

    GetLessonProgressByLessonVersionID(classid: number, lessonversionid: number): Observable<AssignmentVM> {
        let functionName = "GetLessonProgressByLessonVersionID";
        let callUrl = `/api/ELearning/GetLessonProgress/Class/`
        + classid.toString()
        + `/LessonVersion/` + lessonversionid.toString();
        let v = this.httpGet<AssignmentVM>(callUrl, functionName);
        return v;
    }

    GetLessonProgressByClassID(classid: number): Observable<GradebookVM> {
        let functionName = "GetLessonProgressByClassID";
        let callUrl = `/api/ELearning/GetLessonProgress/Class/`
        + classid.toString();
        let v = this.httpGet<GradebookVM>(callUrl, functionName);
        return v;
    }

    GetLessonByID(lessonid: number): Observable<Lesson> {
        let functionName = "GetLessonByID";
        let callUrl =  `/api/ELearning/GetLessonByID/` + lessonid.toString();
        let v = this.httpGet<Lesson>(callUrl, functionName);
        return v;
    }
    GetStudentLessons(lessonid: number): Observable<StudentLesson[]> {
        let functionName = "GetStudentLessons";
        let callUrl = `/api/ELearning/GetStudentAssignmentsByStudentAndLessonID/`
        + lessonid.toString();
        let v = this.httpGet<StudentLesson[]>(callUrl, functionName);
        return v;
    }

    GetELearningDashboardState(): Observable<string> {
        let functionName = "GetELearningDashboardState";
        let callUrl = `/api/getelearningdashboardstate`;

        let v = this.httpGet<string>(callUrl, functionName, true);
        return v;
    }

    SaveELearningDashboardState(state: ELearningDashboardState): Observable<boolean> {
        let functionName = "SaveELearningDashboardState";
        let callUrl = '/api/saveelearningdashboardstate';
        let requestString = JSON.stringify(state, this.replacer);
        let formattedRequestString = "'" + requestString + "'";
        let v = this.httpPost<boolean>(callUrl, functionName, formattedRequestString);
        return v;
    }

    GetClassesForAdminFromTeacherID(teacherID: number): Observable<ELearningDashboardClass[]> {
        let functionName = "getClassesforAdminFromTeacherID";
        let callUrl = '/api/elearningdashboard/' + teacherID.toString();
        let v = this.httpGet<ELearningDashboardClass[]>(callUrl, functionName, true);
        return v;
    }

    UpdateDashboardVisibility(HBClassID: number, visibility: boolean): Observable<boolean> {
        let functionName = "updateDashboardVisibility";
        let callUrl = '/api/Class/' + HBClassID + '/toggleHidden'
        let v = this.httpGet<boolean>(callUrl, functionName, true);

        return v;
    }

    GetClassesForTeacher(showSpinner: boolean = true): Observable<ELearningDashboardClass[]>{
        let functionName = "getClassesForTeacher";
        let callUrl = '/api/elearningdashboard';
        let v = this.httpGet<ELearningDashboardClass[]>(callUrl, functionName, showSpinner);
        return v;
    }

    GetTeachersForAdmin(showSpinner: boolean = true): Observable<Teachers> {
        let functionName = "getTeachersforAdmin";
        let callUrl = '/api/teachers';
        let v = this.httpGet<Teachers>(callUrl, functionName, showSpinner);

        return v;
    }

    GetLinksForAdmin(): Observable<number[]> {
        let functionName = "getAdminLinks";
        let callUrl = '/api/admindashboard/links';
        let v = this.httpGet<number[]>(callUrl, functionName, true);

        return v;
    }

    GetAllGradebookDataForUser() {
        throw new Error('Method not implemented.');
    }

    GetDiagnosticDataForTeacher(): Observable<DiagnosticsVM[]> {
        let functionName = "GetDiagnosticDataForTeacher";
        let callUrl = '/api/ELearning/GetDiagnosticDataForTeacher';
        let v = this.httpGet<DiagnosticsVM[]>(callUrl, functionName, false);

        return v;
    }

    GetDiagnosticDataForAdminByTeacherID(teacherID: number): Observable<DiagnosticsVM[]> {
        let functionName = "GetDiagnosticDataForAdminByTeacherID";
        let callUrl = '/api/ELearning/GetDiagnosticDataForAdminByTeacherID/teacherID/' + teacherID.toString();
        let v = this.httpGet<DiagnosticsVM[]>(callUrl, functionName, false);

        return v;
    }

    GetDiagnosticDataByDiagnosticExamID(diagnosticExamID: number): Observable<DiagnosticVM> {
        let functionName = "GetDiagnosticDataByDiagnosticExamID";
        let callUrl = '/api/ELearning/GetDiagnosticDataByDiagnosticExamID/diagnosticExamID/' + diagnosticExamID.toString();
        let v = this.httpGet<DiagnosticVM>(callUrl, functionName, false);

        return v;
    }

    GetDiagnosticListForTeacher(hbcID : number): Observable<DiagnosticsList[]> {
        let functionName = "GetDiagnosticListForTeacher";
        let callUrl = '/api/ELearning/GetListForDiagnosticExamCreateForTeacher/' + hbcID.toString();
        let v = this.httpGet<DiagnosticsList[]>(callUrl, functionName, false);

        return v;
    }

    CreateDiagnostic(model: CreateDiagnosticVM): Observable<DiagnosticVM> {
        let functionName = "CreateDiagnostic";
        let callUrl = 'api/ELearning/CreateDiagnostic';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<DiagnosticVM>(callUrl, functionName, requestString, false);
        return v;
    }

    GetSkippedStudentsList(diagExamID: number): Observable<StudentForDiagnostic[]> {
        let functionName = "GetSkippedStudentsList";
        let callUrl = '/api/ELearning/GetDiagExamSkippedList/' + diagExamID;
        let v = this.httpGet<StudentForDiagnostic[]>(callUrl, functionName, false);

        return v;
    }

    DiagnosticSkipStudent(model: DiagnosticSkipStudentModel): Observable<boolean> {
        let functionName = "DiagnosticSkipStudent";
        let callUrl = 'api/ELearning/AddDiagExamSkipStudent';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    AssignStudentDiagnostic(model: AssignStudentDiagnosticModel): Observable<boolean> {
        let functionName = "AssignStudentDiagnostic";
        let callUrl = 'api/ELearning/AssignStudentDiagnostic';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    AssignAllDiagnostic(model: AssignAllDiagnosticModel): Observable<boolean> {
        let functionName = "AssignAllDiagnostic";
        let callUrl = 'api/ELearning/AssignAllDiagnostic';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    DiagnosticLessonsSkipStudent(model: DiagnosticLessonsSkipStudentModel): Observable<boolean> {
        let functionName = "DiagnosticLessonsSkipStudent";
        let callUrl = 'api/ELearning/AddDiagLessonsSkipStudent';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    AssignDiagnosticLessons(model: AssignDiagnosticLessonsModel) : Observable<boolean> {
        //assign all students
        let functionName = "AssignDiagnosticLessons";
        let callUrl = 'api/ELearning/AssignDiagnosticLessons';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    AssignStudentDiagnosticLessons(model: AssignStudentDiagnosticLessonsModel) : Observable<boolean> {
        // assign one student
        let functionName = "AssignStudentDiagnosticLessons";
        let callUrl = 'api/ELearning/AssignStudentDiagnosticLessons';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    UnassignDiagnosticLessons(model: UnassignDiagnosticLessonsVM): Observable<boolean>{
        let functionName = "UnassignDiagnosticLessons";
        let callUrl = 'api/ELearning/UnassignDiagnosticLessons';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    DiagnosticRemoveFromSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean> {
        let functionName = "DiagnosticRemoveFromSkipStudent";
        let callUrl = 'api/ELearning/RemoveDiagExamSkipStudent';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    };

    DiagnosticRemoveFromLessonsSkipStudent(model: DiagnosticRemoveFromSkipStudentModel): Observable<boolean> {
        let functionName = "DiagnosticRemoveFromLessonsSkipStudent";
        let callUrl = 'api/ELearning/RemoveDiagLessonsSkipStudent';
        let requestString = JSON.stringify(model, this.replacer);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    };
 GetViewWorkData(model: ViewWorkDataModel): Observable<ViewWorkDataVM> {
        let functionName = "GetviewWorkData";
        let callUrl = '/api/ELearning/GetViewWork';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<ViewWorkDataVM>(callUrl, functionName, requestString);
        return v;
    }

    SubmitViewWorkData(model: SubmitViewWorkModel): Observable<SubmitViewWorkResponseModel> {
        let functionName = "SubmitViewWorkData";
        let callUrl = '/api/ELearning/SubmitViewWork';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<SubmitViewWorkResponseModel>(callUrl, functionName, requestString);
        return v;
    }

    GetAssignmentAttemptsForViewWorkDialog(studentID: number, assignmentID: number): Observable<ViewWorkDialogAssignmentAttempt[]>{
        let functionName = "GetAssignmentAttemptsForViewWorkDialog";
        let callUrl = '/api/ELearning/GetAssignmentAttemptsForViewWorkDialog';
        let model = new GetViewWorkDialogAssignmentAttempts();
        model.StudentID = studentID;
        model.AssignmentID = assignmentID;

        let requestString = JSON.stringify(model);
        let v = this.httpPost<ViewWorkDialogAssignmentAttempt[]>(callUrl, functionName, requestString);
        return v;
    }

    private replacer = (key, value) =>
        typeof value === 'undefined' ? null : value;

    private httpGet<T>(callUrl: string, functionName: string, spinner: boolean = false): Observable<T> {

        if (spinner){
            this.incrementSpinner(functionName);
        }

        let v = this
            .http
            .get<T>(this.httpUrl + callUrl)
            .pipe(
                catchError(super.handleError<T>(functionName, null)),
                tap(_ => {
                    if (spinner){
                        this.decrementSpinner(functionName)
                    }
                })
            );

        return v;
    }

    private httpPost<T>(callUrl: string, functionName: string, requestString: string, spinner: boolean = false): Observable<T>{
        if(spinner){
            this.incrementSpinner(functionName);
        }

        let v = this
            .http
            .post<T>(this.httpUrl + callUrl, requestString, this.httpOptions)
            .pipe(
                catchError(super.handleError<T>(functionName, null)),
                tap(_ => {
                    if(spinner){
                        this.decrementSpinner(functionName)
                    }
                })
            );

        return v;
    }

    private incrementSpinner(apiSignature: string): void {
        this.serviceFactory.getSpinnerService().enqueueLoad(apiSignature);
    }

    private decrementSpinner(apiSignature: string): void {
        this.serviceFactory.getSpinnerService().dequeueLoad(apiSignature);
    }

    SetServiceFactory(factory: IServiceFactory): void {
        this.serviceFactory = factory;
    }


    CreateAssignments(model: CreateAssignmentsModel): Observable<boolean> {
      return; // PUSHED BACK UNTIL WE DO CREATE ASSIGNMENTS
    }
    GetDefaultAssignmentOptions(): Observable<CreateAssignmentOptions> {
        return; // PUSHED BACK UNTIL WE DO CREATE ASSIGNMENTS
    }
    GetClassWithStudents(classID: number): Observable<ClassWithStudentsForListing> {
        return; // PUSHED BACK UNTIL WE DO CREATE ASSIGNMENTS
    }
    GetClassesWithStudent(): Observable<ClassWithStudentsForListing[]> {
        return; // PUSHED BACK UNTIL WE DO CREATE ASSIGNMENTS
    }

    CreateAccount(model: CreateAccountModel): Observable<boolean> {
        let functionName = "CreateAccount";
        let callUrl = 'api/Login/NewConsumerCurriculumAccount';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, false);
        return v;
    }

    GetUserDetailsForEdit(): Observable<CreateAccountModel> {
        let functionName = "EditUser";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetUserDetailsForEdit';
        let v = this.httpGet<CreateAccountModel>(callUrl, functionName, false);

        return v;
    }
    EditUser(model: CreateAccountModel): Observable<boolean> {
        let functionName = "EditUser";
        let callUrl = '/api/ELearning/ConsumerCurriculum/UpdateUserDetails';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    GetCurriculumData(): Observable<CurriculaVMModel> {
        // ConsumerCurriculumSearch in RP
        let functionName = "GetCurriculumData";
        let callUrl = '/api/ELearning/ConsumerCurriculum/Search';
        let v = this.httpGet<CurriculaVMModel>(callUrl, functionName, false);

        return v;
    }

    AssignCurriculum(model: ExistingStudentCurriculumRegisterModel): Observable<PaymentProviderRequestResult> {
        // student ID won't be null. If they need to register a new student, they will do that first in another api call then call this one on success.
        let functionName = "AssignCurriculum";
        let callUrl = '/api/ELearning/ConsumerCurriculum/AssignCurriculum';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<PaymentProviderRequestResult>(callUrl, functionName, requestString);
        return v;
    }

    AssignCurriculumForStudentConsumerCurriculum(model: ExistingStudentConsumerCurriculumRegisterModel): Observable<PaymentProviderRequestResult> {
        // student ID won't be null. If they need to register a new student, they will do that first in another api call then call this one on success.
        let functionName = "AssignCurriculumForStudentConsumerCurriculum";
        let callUrl = '/api/ELearning/ConsumerCurriculum/AssignCurriculumForStudentConsumerCurriculum';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<PaymentProviderRequestResult>(callUrl, functionName, requestString);
        return v;
    }

    HasAlreadyPaidByStudentClassID(studentID: number, classID: number):Observable<HasAlreadyPaidRedirectModel>{
        let functionName = "HasAlreadyPaidByStudentClassID";
        let callUrl = '/api/ConsumerCurriculum/PaidAlreadyByStudentClassID/' + studentID + '/' + classID;
        let v = this.httpGet<HasAlreadyPaidRedirectModel>(callUrl, functionName, false);

        return v;
    }

    HasAlreadyPaidByStudentConsumerCurrID(sccID: number): Observable<HasAlreadyPaidRedirectModel>{
        let functionName = "HasAlreadyPaidByStudentConsumerCurrID";
        let callUrl = '/api/ConsumerCurriculum/PaidAlreadyByStudentConsumerCurriculumID/' + sccID;
        let v = this.httpGet<HasAlreadyPaidRedirectModel>(callUrl, functionName, false);

        return v;
    }
   
    
    GetStudentList(): Observable<StudentModel[]> {
        // ConsumerCurriculumGetStudentListing in RP
        let functionName = "GetStudentList";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetStudentList';
        let v = this.httpGet<StudentModel[]>(callUrl, functionName, false);

        return v;
    }

    GetStudentLesson(model: SelfServiceGetLessonModel): Observable<SelfGetLessonReturnModel>{
        let functionName = "GetStudentLesson";
        let callUrl = '/api/ELearning/ConsumerCurriculum/StudentGetLesson';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<SelfGetLessonReturnModel>(callUrl, functionName, requestString);
        return v;
    }
    LoginAsStudent(model: LoginAsStudentModel): Observable<boolean>{
        let functionName = "LoginAsStudent";
        let callUrl = '/api/ELearning/ConsumerCurriculum/LoginAsStudent';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString, true);
        return v;
    }
    LoginAndGetStudentDemo(model: SelfServiceGetLessonModel):Observable<SelfGetLessonReturnModel>{
        let functionName = "LoginAndGetStudentDemo";
        let callUrl = '/api/ELearning/ConsumerCurriculum/LoginAsStudentAndGetDemo';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<SelfGetLessonReturnModel>(callUrl, functionName, requestString);
        return v;
    }

    GetSelectedCurriculum(curriculumID: number): Observable<SelectedCurriculumModel> {
        // ConsumerCurriculumSearch in RP
        let functionName = "GetSelectedCurriculum";
        let callUrl = '/api/ELearning/ConsumerCurriculum/Search/' + curriculumID;
        let v = this.httpGet<SelectedCurriculumModel>(callUrl, functionName, false);

        return v;
    }

    RegisterNewStudent(model: RegisterNewStudent): Observable<number> {
        let functionName = "RegisterNewStudent";
        let callUrl = '/api/ELearning/ConsumerCurriculum/RegisterNewStudent';

        let requestString = JSON.stringify(model);

        let v = this.httpPost<number>(callUrl,functionName,requestString,false);

        return v;
    }

    GetStudentCourseList(): Observable<StudentCourseModel> {
        //ConsumerCurriculumStudentAssignmentListing in RP
        let functionName = "GetStudentCourseList";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetStudentAssignmentListing';
        let v = this.httpGet<StudentCourseModel>(callUrl, functionName, false);

        return v;
    }

    GetCurriculumViewDataByClassId(classID: number): Observable<CurriculumViewListing> {
        //GetCurriculumViewListing in RP
        let functionName = "GetCurriculumViewDataByClassId";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetConsumerCurriculumViewListing/ClassID/' + classID;
        let v = this.httpGet<CurriculumViewListing>(callUrl, functionName, false);

        return v;
    }

    GetCurriculumProductLevelPrice(curriculumID: number): Observable<CurriculumProductLevelPrice[]> {
        //GetCurriculumViewListing in RP
        let functionName = "GetCurriculumViewDataByClassId";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetCurriculumProductLevelPrice/CurriculumID/' + curriculumID.toString();
        let v = this.httpGet<CurriculumProductLevelPrice[]>(callUrl, functionName, false);

        return v;
    }

    GetRedirectModelFromProcessPaymentFailure(guid: string): Observable<PaymentFailureRedirectModel> {
        //GetCurriculumViewListing in RP
        let functionName = "GetRedirectModelFromProcessPaymentFailure";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetRedirectModelFromProcessPaymentFailure/guid/' + guid;
        let v = this.httpGet<PaymentFailureRedirectModel>(callUrl, functionName, false);

        return v;
    }


    GetRedirectModelFromProcessPaymentSuccess(guid: string): Observable<PaymentSuccessRedirectModel> {
        //GetCurriculumViewListing in RP
        let functionName = "GetRedirectModelFromProcessPaymentSuccess";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetRedirectModelFromProcessPaymentSuccess/guid/' + guid;
        let v = this.httpGet<PaymentSuccessRedirectModel>(callUrl, functionName, false);

        return v;
    }

    GetDemoRedirect(model: GetDemoRedirectModel):Observable<DemoRedirectModel>{
        let functionName = "GetDemoRedirect";
        let callUrl = '/api/ELearning/ConsumerCurriculum/GetDemoRedirect';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<DemoRedirectModel>(callUrl, functionName, requestString);
        return v;
    }

    LoginUser(model: LoginAccountModel): Observable<LoginAccountResult> {
        let functionName = "GetDemoRedirect";
        let callUrl = 'api/login/ConsumerCurriculumLogin';
        let requestString = JSON.stringify(model);
        let v = this.httpPost<LoginAccountResult>(callUrl, functionName, requestString);
        return v;
    }

    GetStudentConsumerCurriculum(StudentID: number, curriculumID: number): Observable<StudentConsumerCurriculum> {
        let functionName = "GetStudentConsumerCurriculum";
        let callUrl = 'api/login/GetStudentConsumerCurriculum';

        var model: StudentConsumerCurriculumRequest = {
            StudentID: StudentID,
            CurriculumID: curriculumID
        }

        let requestString = JSON.stringify(model);
        let v = this.httpPost<StudentConsumerCurriculum>(callUrl, functionName, requestString);
        return v;
    }

    GetConsumerCurriculumDiagnosticReport(model: DiagnosticReportRequest): Observable<DiagnosticReport> {
        let functionName = "GetConsumerCurriculumDiagnosticReport";
        let callUrl = 'api/ELearning/ConsumerCurriculum/GetConsumerCurriculumDiagnosticReport';

        
        let requestString = JSON.stringify(model);
        let v = this.httpPost<DiagnosticReport>(callUrl, functionName, requestString);
        return v;
    }

    GetDemoResultData(studentConsumerCurriculumID: number): Observable<DemoResultData> {
        let functionName = "GetDemoResultData";
        let callUrl = 'api/ELearning/ConsumerCurriculum/GetDemoResultDataByStudentConsumerCurriculumID';

        var model = {
            StudentConsumerCurriculumID: studentConsumerCurriculumID
        };

        let requestString = JSON.stringify(model);
        let v = this.httpPost<DemoResultData>(callUrl, functionName, requestString);
        return v;
    }

    GetDemoResultDataByStudentAndClass(studentID: number, classID: number): Observable<DemoResultData> {
        let functionName = "GetDemoResultData";
        let callUrl = 'api/ELearning/ConsumerCurriculum/GetDemoResultDataByStudentAndClass';

        var model = {
            StudentID: studentID,
            ClassID: classID
        }

        let requestString = JSON.stringify(model);
        let v = this.httpPost<DemoResultData>(callUrl, functionName, requestString);
        return v;
    }

    ValidateParentPassword(pass: string): Observable<boolean> {
        let functionName = "ValidateParentPassword";
        let callUrl = 'api/ELearning/ConsumerCurriculum/ValidateParentPassword';

        var model = {
            Password: pass,
        }

        let requestString = JSON.stringify(model);
        let v = this.httpPost<boolean>(callUrl, functionName, requestString);
        return v;
    }

    GetIsTeacher(): Observable<boolean> {
        let functionName = "GetIsTeacher";
        let callUrl = 'api/ConsumerCurriculum/GetIsTeacher';
        let v = this.httpGet<boolean>(callUrl, functionName, false);

        return v;
    }

    CheckIsNewComer():Observable<boolean>{
        let functionName = "checkIsNewComer";
        let callUrl = 'api/ConsumerCurriculum/IsNewComer';
        let v = this.httpGet<boolean>(callUrl, functionName, false);

        return v;
    }

    ConfirmEmail(guid: string): Observable<EmailConfirmationModel>{
        let functionName = "ConfirmEmail";
        let callUrl = 'api/ConsumerCurriculum/ConfirmEmail/' + guid;
        let v = this.httpGet<EmailConfirmationModel>(callUrl, functionName, false);

        return v;
    }

    ConfirmEmailByUser(): Observable<EmailConfirmationModel>{
        let functionName = "ConfirmEmail";
        let callUrl = 'api/ConsumerCurriculum/ConfirmEmail';
        let v = this.httpGet<EmailConfirmationModel>(callUrl, functionName, false);

        return v;
    }

    ResendConfirmationEmail(guid: string): Observable<boolean>{
        let functionName = "ResendConfirmationEmail";
        let callUrl = 'api/ConsumerCurriculum/ResendConfirmationEmail/' + guid;
        let v = this.httpGet<boolean>(callUrl, functionName, false);

        return v;
    }

    GetStandardsGrowthReport(classid: number): Observable<StandardsGrowthReportModel>{
        let functionName = "GetStandardsGrowthReport";
        let callUrl = 'api/ELearning/ConsumerCurriculum/GetStandardsGrowthReport/ClassID/' + classid;
        let v = this.httpGet<StandardsGrowthReportModel>(callUrl, functionName, false);

        return v;
    }
}
